// Local Components
import S from "./ProfileHeader.module.scss";
import { NavUserImage } from "sj-ui-toolkit/src/atlas/components/UserNavBar/NavUserImage/NavUserImage";

// External Libraries
import C from "classnames";
import { Skeleton } from "primereact/skeleton";

// Hooks & Helpers
import { formatTotalTime, formatPoints, formatLastMonthPoints } from "sj-ui-toolkit/src/utils";
import { useUserContext } from "sj-ui-toolkit/src/atlas/contexts/User/UserContextProvider";

export function ProfileHeader() {
  const { user, isLoading } = useUserContext();
  const name = user?.name?.givenName;

  const {
    totalTime,
    lastMonthTotalTime,
    lastMonthPoints,
    totalPoints,
    currentLevel = {},
  } = user?.railsProfile || {};

  const { levelName } = currentLevel ?? {};
  const formattedLastMonthPoints = formatLastMonthPoints(lastMonthPoints);

  return (
    <div className={S.root}>
      <div className={S.userInfo}>
        <NavUserImage customSize="96px" user={user ?? undefined} isLoading={isLoading} />
        <div>
          <h1 className="atlas-h1">{name}</h1>
          <div className="atlas-h4 capitalize">
            {isLoading ? <Skeleton width="50%" /> : levelName}
          </div>
        </div>
      </div>
      <div className={S.userStats}>
        <div className={C(S.statColumn, "atlas-h5 text-muted-aaa")}>
          <span>TOTAL POINTS</span>
          <span className={S.statValue}>
            {isLoading ? (
              <Skeleton width="75%" height="1rem" className="my-1" />
            ) : (
              <strong>{formatPoints(totalPoints)}</strong>
            )}
          </span>
          <span>
            {isLoading ? (
              <Skeleton width="90%" height="1rem" className="my-1" />
            ) : (
              `${formattedLastMonthPoints} points in the last 30 days`
            )}
          </span>
        </div>
        <div className={C(S.statColumn, "atlas-h5 text-muted-aaa")}>
          <span>TOTAL TIME ON THE PLATFORM</span>
          <span className={S.statValue}>
            {isLoading ? (
              <Skeleton width="75%" height="1rem" className="my-1" />
            ) : (
              <strong>{formatTotalTime(totalTime)}</strong>
            )}
          </span>
          <span>
            {isLoading ? (
              <Skeleton width="90%" height="1rem" className="my-1" />
            ) : (
              `${formatTotalTime(lastMonthTotalTime)} in the last 30 days`
            )}
          </span>
        </div>
      </div>
    </div>
  );
}
